import axios from "../axios";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { login } from "../slices/userSlice";
import { useNavigate } from "react-router-dom";

const InsertNameScreen = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { user, access_token } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const submitForm = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const name = e.target.name.value;
    const id = user.id;
    console.log(id);
    axios
      .patch(
        "user/profile",
        {
          name,
          id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: access_token,
          },
        }
      )
      .then((res) => {
        dispatch(
          login({
            user: { ...user, name: name },
            access_token: access_token,
            has_name: true,
          })
        );

        setIsLoading(false);

        navigate("/collections");
      })
      .catch((err) => {
        setIsLoading(false);
        let data = err.response?.data;
        if (!data?.success) {
          toast.error("Error: " + (data?.error?.message || "Something went wrong"));
        }
      });
  };
  return (
    <div className="grid gap-10 w-full place-items-center h-[calc(100vh-125px)] absolute top-[75px]">
      <div className="col-span-2 md:col-span-1 h-[75%] items-center justify-center flex-col flex sm:w-2/4 w-full">
        <img
          className="w-[50%] md:object-contain object-cover"
          src="/Images/Insert_name.svg"
          alt=""
        />
        <div className="flex flex-col w-[85%] md:w-[75%] lg:w-[70%] mt-4  gap-5">
          {/* Avatar */}
          <div className="flex justify-center  flex-col mb-2 gap-1">
            <h2 className="text-3xl md:text-3xl">
              Please enter your legal name to continue
              <span className="wave text-4xl md:text-3xl">👇</span>
            </h2>
            <p className="text-gray-500 font-normal text-sm ml-1">
              Enter the name that is stated in your employment agreement with PW{" "}
              <span className="text-red-600">*</span>
            </p>
            {/* <i className="border-[#dedbf6] p-1 border-4 rounded-full fa-solid fa-circle-user text-6xl text-primary"></i> */}
          </div>

          {/* Form */}
          <form onSubmit={submitForm}>
            <div className="flex flex-col w-full gap-4">
              <div className="flex flex-col gap-2">
                <label className="">Name</label>
                <input
                  name="name"
                  required
                  data-testid="userIdInput"
                  className="bg-[#f8f8f8] font-normal border-[2.6px] border-[#efefef] placeholder:text-[#b4b4b4] placeholder:font-normal focus:!ring-primary px-3.5 py-3 rounded-md"
                  type="text"
                  placeholder="Type name here..."
                />
              </div>
              <button
                type="submit"
                className="bg-primary text-white px-14 py-2 rounded-md"
              >
                {isLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default InsertNameScreen;
